module.exports = __webpack_public_path__ + "img/img-archive03.d429737c.png";